import { render, staticRenderFns } from "./configAutoBan.vue?vue&type=template&id=38eb11f3&"
import script from "./configAutoBan.vue?vue&type=script&lang=js&"
export * from "./configAutoBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports